/* eslint-disable prefer-rest-params */
import { LibCategories, getConsent } from "src/utils/consent";
import { loadScript } from "src/utils/scriptLoader";
import uuid from "uuid";
import Cookies from "js-cookie";

declare const window: Window & {
  ire_o: string;
  ire: any;
};

/**
 * Gets or creates a customProfileId (UUID) for Impact tracking
 * This is a browser-level identifier independent of user authentication
 * as required by Impact.com guidelines for customProfileId
 * Requires targeting cookies consent before storing persistent identifier
 */
export function getOrCreateCustomProfileId(): string {
  const cookieName = "ircpid";

  // Check if we have targeting cookies consent
  const currentConsent = getConsent();
  if (!currentConsent.includes(LibCategories.targetingCookies)) {
    // Return empty string when consent not granted (per Impact documentation)
    return "";
  }

  let profileId = Cookies.get(cookieName);

  if (!profileId) {
    profileId = uuid.v4();
    // Set secure cookie with 30 days expiration (matches referral window)
    Cookies.set(cookieName, profileId, {
      expires: 30,
      secure: window.location.protocol === "https:",
      sameSite: "lax",
    });
  }

  return profileId;
}

window.ire_o = "ire";
window.ire =
  window.ire ||
  function ire() {
    (window.ire.a = window.ire.a || []).push(arguments);
  };

export function loadImpact() {
  return loadScript(
    "https://utt.impactcdn.com/A1264905-0109-4989-91e2-e8a8aaca9b161.js",
    [LibCategories.targetingCookies],
    { enableCORS: false }
  );
}
